import { render, staticRenderFns } from "./RequestReceiptButton.vue?vue&type=template&id=2f59112a"
import script from "./RequestReceiptButton.vue?vue&type=script&lang=js"
export * from "./RequestReceiptButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports